import React from 'react';
import Alert from 'react-bootstrap/Alert'
import './alert.css'

export default function Popup (props) {
  return commonPopup ('popup-container', props)
}

export function RelativePopup (props) {
  return commonPopup ('relative-popup', props)
}

function commonPopup (clName, props) {
  const variant = props?.popupStyle ?? 'dark'
  return (
    props?.popupMsg ? 
    <div className={clName}>
      <Alert className="popup-alert" variant={variant} onClose={props.onClose} dismissible>
        {props.popupMsg}
        <div>{props?.details}</div>
        <div><Alert.Link href='#'onClick={props.moreinfo}>{props.link}</Alert.Link></div>
      </Alert></div>
    : null
  )  
}